import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { importProvidersFrom, isDevMode, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '@env/environment';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { AppTranslateLoader } from 'app/core/i18n/app-translate-loader';
import { appHttpInterceptor } from 'app/core/interceptors/http.interceptor';
import { AppUpdateService } from 'app/core/services/app-update.service';
import { LanguageService } from 'app/core/services/language.service';
import { ThemeService } from 'app/core/services/theme.services';
import { NZ_I18N, pt_BR } from 'ng-zorro-antd/i18n';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';
import 'zone.js';
import { App } from './app/app';
import { appConfig } from './app/app.config';

registerLocaleData(localePt);

const sentryEnabled = Boolean(environment.sentryDsn);
const isProdSentry = environment.sentryEnvironment === 'production';

if (sentryEnabled) {
	Sentry.init({
		dsn: environment.sentryDsn,
		environment: environment.sentryEnvironment,
		integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
		tracesSampleRate: isProdSentry ? 0.2 : 1.0,
		tracePropagationTargets: ['localhost', '127.0.0.1', /^https:\/\/api\.marianalino\.com\.br/],
		replaysSessionSampleRate: isProdSentry ? 0.1 : 0,
		replaysOnErrorSampleRate: 1.0,
		enableLogs: true
	});
}

bootstrapApplication(App, {
	...appConfig,
	providers: [
		...(appConfig.providers ?? []),
		provideHttpClient(withFetch(), withInterceptors([appHttpInterceptor])),
		provideAnimations(),
		provideServiceWorker('ngsw-worker.js', {
			enabled: !isDevMode(),
			registrationStrategy: 'registerWhenStable:30000'
		}),
		{ provide: LOCALE_ID, useValue: 'pt-BR' },
		{ provide: NZ_I18N, useValue: pt_BR },
		importProvidersFrom(
			TranslateModule.forRoot({
				fallbackLang: 'pt',
				compiler: {
					provide: TranslateCompiler,
					useClass: TranslateMessageFormatCompiler
				},
				loader: {
					provide: TranslateLoader,
					useClass: AppTranslateLoader
				}
			})
		)
	]
}).then((appRef) => {
	const injector = appRef.injector;

	injector.get(ThemeService).initialize();
	injector.get(LanguageService).initialize();
	injector.get(AppUpdateService).initialize();
});
